import { getStore } from '@/store'
import { actionCreators as dialogActions } from '@/store/Dialogs'
import { dialogTypes } from '@/dialogs'

function openErrorDialog ({ customErrorText, customTitle } = {}) {
  getStore().dispatch(dialogActions.openDialog({
    dialogType: dialogTypes.alert,
    title: customTitle || 'Common.Error',
    content: customErrorText || 'Common.ServerInternalError'
  }))
}

function openConfirmDialog ({ customConfirmText, customTitle, onAction, onClose }) {
  getStore().dispatch(dialogActions.openDialog({
    dialogType: dialogTypes.confirm,
    title: customTitle || 'Common.Confirm',
    content: customConfirmText || 'Common.AreYouSure',
    onAction: onAction || (() => {}),
    onClose: onClose || (() => {})
  }))
}

function openAlertDialog ({ title, text }) {
  getStore().dispatch(dialogActions.openDialog({
    dialogType: dialogTypes.alert,
    title: title,
    content: text
  }))
}

export { openErrorDialog, openConfirmDialog, openAlertDialog }



// WEBPACK FOOTER //
// ./src/utils/dialogHelpers.js